import { StructureNodeDef } from "../parser/definition/types/StructureNodeDef";
import { convertChildNodesPropsToChildNodes } from "./convertChildNodesPropsToChildNodes";
import { convertConnectionsToChildConnections } from "./convertConnectionsToChildConnections";
import { StructureNode } from "./types/StructureNodes";
import { getModuleName } from "./utils/getModuleName";
import { getNodeName } from "./utils/getNodeName";
import { getPortAssignment } from "./utils/getPortAssignment";

export function convertStructureNodeDefToLegacyOne(id: string, nodeName: string, nodeDef: StructureNodeDef<Record<string, any>, Record<string, any>, any>): StructureNode {
    return {
        id,
        name: getNodeName(nodeName),
        description: nodeName,
        module: getModuleName(nodeName),
        childNodes: convertChildNodesPropsToChildNodes(nodeDef.childNodesProps),
        childConnections: convertConnectionsToChildConnections(nodeDef.connections),
        inputNames: nodeDef.inputNames.map(item => item),
        outputNames: nodeDef.outputNames.map(item => item),
        inputAssignments: getPortAssignment(nodeDef.exposedInputs),
        outputAssignments: getPortAssignment(nodeDef.exposedOutputs),
        stateProperties: []
    }

}
